/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { CapiCodeId } from './capiCodeId';
import { TeilDatumSearchRequestMeta } from './teilDatumSearchRequestMeta';
import { HistorySearchOptionsMeta } from './historySearchOptionsMeta';
import { ElasticSearchOptions } from './elasticSearchOptions';


export interface PersonGbSearchErweitertRequestMeta { 
    vorname?: string;
    mVorname?: FieldMetaData;
    rolleUebrigeBerechtigeVormerkung?: boolean;
    mRolleUebrigeBerechtigeVormerkung?: FieldMetaData;
    plz?: string;
    mPlz?: FieldMetaData;
    rolleSchuldner?: boolean;
    mRolleSchuldner?: FieldMetaData;
    geburtsdatum?: TeilDatumSearchRequestMeta;
    mGeburtsdatum?: FieldMetaData;
    rolleEigentuemer?: boolean;
    mRolleEigentuemer?: FieldMetaData;
    isSearchEigentuemerEnabled?: boolean;
    mIsSearchEigentuemerEnabled?: FieldMetaData;
    personStammSort?: PersonGbSearchErweitertRequestMeta.PersonStammSortEnum;
    mPersonStammSort?: FieldMetaData;
    rolle?: PersonGbSearchErweitertRequestMeta.RolleEnum;
    mRolle?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    historySearchOptions?: HistorySearchOptionsMeta;
    mHistorySearchOptions?: FieldMetaData;
    rolleUebrigeBerechtigeDienstbarkeit?: boolean;
    mRolleUebrigeBerechtigeDienstbarkeit?: FieldMetaData;
    codeSchuldner?: CapiCodeId;
    mCodeSchuldner?: FieldMetaData;
    mPersonStammVersionArtList?: Array<PersonGbSearchErweitertRequestMeta.MPersonStammVersionArtListEnum>;
    mMPersonStammVersionArtList?: FieldMetaData;
    rolleUebrigeBerechtigeGrundlast?: boolean;
    mRolleUebrigeBerechtigeGrundlast?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    rolleGlaeubiger?: boolean;
    mRolleGlaeubiger?: FieldMetaData;
    rolleUebrigeBerechtigeAnmerkung?: boolean;
    mRolleUebrigeBerechtigeAnmerkung?: FieldMetaData;
    isSearchGlaeubigerSchuldnerEnabled?: boolean;
    mIsSearchGlaeubigerSchuldnerEnabled?: FieldMetaData;
    ahvVersichertennummer?: string;
    mAhvVersichertennummer?: FieldMetaData;
    uid?: string;
    mUid?: FieldMetaData;
    sitz?: string;
    mSitz?: FieldMetaData;
    glaeubigerrolle?: PersonGbSearchErweitertRequestMeta.GlaeubigerrolleEnum;
    mGlaeubigerrolle?: FieldMetaData;
    mGlaeubigerrolleList?: Array<PersonGbSearchErweitertRequestMeta.MGlaeubigerrolleListEnum>;
    mMGlaeubigerrolleList?: FieldMetaData;
    elasticSearchOptions?: ElasticSearchOptions;
    mElasticSearchOptions?: FieldMetaData;
    hausnummer?: string;
    mHausnummer?: FieldMetaData;
    personStammVersionArt?: PersonGbSearchErweitertRequestMeta.PersonStammVersionArtEnum;
    mPersonStammVersionArt?: FieldMetaData;
    isSearchUebrigeBerechtigteEnabled?: boolean;
    mIsSearchUebrigeBerechtigteEnabled?: FieldMetaData;
    ort?: string;
    mOrt?: FieldMetaData;
    codeGlaeubiger?: CapiCodeId;
    mCodeGlaeubiger?: FieldMetaData;
    ledigname?: string;
    mLedigname?: FieldMetaData;
    sortDirection?: PersonGbSearchErweitertRequestMeta.SortDirectionEnum;
    mSortDirection?: FieldMetaData;
    strasse?: string;
    mStrasse?: FieldMetaData;
}
export namespace PersonGbSearchErweitertRequestMeta {
    export type PersonStammSortEnum = 'BEZEICHNUNG' | 'ART';
    export const PersonStammSortEnum = {
        BEZEICHNUNG: 'BEZEICHNUNG' as PersonStammSortEnum,
        ART: 'ART' as PersonStammSortEnum
    };
    export type RolleEnum = 'EIGENTUEMER' | 'UEBRIGE_BERECHTIGTE' | 'GLAEUBIGER_SCHULDNER' | 'ALLE';
    export const RolleEnum = {
        EIGENTUEMER: 'EIGENTUEMER' as RolleEnum,
        UEBRIGEBERECHTIGTE: 'UEBRIGE_BERECHTIGTE' as RolleEnum,
        GLAEUBIGERSCHULDNER: 'GLAEUBIGER_SCHULDNER' as RolleEnum,
        ALLE: 'ALLE' as RolleEnum
    };
    export type MPersonStammVersionArtListEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const MPersonStammVersionArtListEnum = {
        NATUERLICHEPERSON: 'NATUERLICHE_PERSON' as MPersonStammVersionArtListEnum,
        SCHWEIZERISCHEJURISTISCHEPERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as MPersonStammVersionArtListEnum,
        OEFFENTLICHEKOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as MPersonStammVersionArtListEnum,
        AUSLAENDISCHERECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as MPersonStammVersionArtListEnum
    };
    export type GlaeubigerrolleEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const GlaeubigerrolleEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        NUTZNIESSER: 'NUTZNIESSER' as GlaeubigerrolleEnum,
        ANDEREROLLE: 'ANDEREROLLE' as GlaeubigerrolleEnum
    };
    export type MGlaeubigerrolleListEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const MGlaeubigerrolleListEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        NUTZNIESSER: 'NUTZNIESSER' as MGlaeubigerrolleListEnum,
        ANDEREROLLE: 'ANDEREROLLE' as MGlaeubigerrolleListEnum
    };
    export type PersonStammVersionArtEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const PersonStammVersionArtEnum = {
        NATUERLICHEPERSON: 'NATUERLICHE_PERSON' as PersonStammVersionArtEnum,
        SCHWEIZERISCHEJURISTISCHEPERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as PersonStammVersionArtEnum,
        OEFFENTLICHEKOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as PersonStammVersionArtEnum,
        AUSLAENDISCHERECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as PersonStammVersionArtEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
}


